import BarrageContainer from "./barrageContainer/index.js";
import UIComponent from "../common/UIComponent";
import PlayBtn from "./playBtn/index.js";
import CurrentTime from "./currentTime/index.js";
import DefinitionBtn from "./definitionBtn/index.js";
import SpeedBtn from "./speedBtn/index.js";
import Progress from "./progress/index.js";
import FullscreenBtn from "./fullscreenBtn/index.js";
import VolumeBtn from "./volumeBtn/index.js";
import ConfigBtn from "./configBtn/index.js";
import { debounce } from "../common/Utils";
import "./index.css";

export default class Component extends UIComponent {
  constructor(elementId, interfaces) {
    super();
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.init();
    window.onresize = debounce((e) => {
      const width = document.querySelector(this.elementId).offsetWidth;
      if (width <= 400) {
        document.querySelector(".vhallPlayer-container").style.display = "none"
      } else {
        document.querySelector(".vhallPlayer-container").style.display = "block"
      }
    }, 100);

    let isMouseMove = false;
    let timer = null;
    document.querySelector(`${this.elementId}`).onmousemove = e => {

      isMouseMove = true;

      document.querySelector(".vhallPlayer-container").classList.remove("hide")

      clearTimeout(timer);

      timer = setTimeout(function () {
        if (e.target.tagName === "VIDEO") {
          isMouseMove = false;
          document.querySelector(".vhallPlayer-container").classList.add("hide")
        }

      }, 5000)

    };

  }

  init() {
    this.UIMain = document.createElement("div");
    this.UIMain.setAttribute("class", "vhallPlayer-container");
    this.UIMain.innerHTML = `
        <div class="vhallPlayer-progress-box"></div>
        <div class="vhallPlayer-controller-box">
          <div class="v-c-left"></div>
          <div class="v-c-right"></div>
        </div>
    `.trim();
    this.appendChild(this.elementId, this.UIMain);
    new BarrageContainer(".vhallPlayer-container", this.interfaces);
    new PlayBtn(".v-c-left", this.interfaces);
    this.interfaces.isLive ? undefined : new CurrentTime(".v-c-left", this.interfaces);
    new DefinitionBtn(".v-c-right", this.interfaces);
    this.interfaces.isLive ? undefined : new SpeedBtn(".v-c-right", this.interfaces);
    new VolumeBtn(".v-c-right", this.interfaces);
    new ConfigBtn(".v-c-right", this.interfaces);
    new FullscreenBtn(".v-c-right", this.interfaces);
    this.interfaces.isLive ? undefined : new Progress(".vhallPlayer-progress-box", this.interfaces);
  }

}